// An incident (data-model.md "incidents"; shift-engine §2).
//
// A Sev1 triggers automatic containment out of band (D72), not a wait for a human. The
// public status page reads a redacted view; the full timeline is in `audit_log` (D38).
// `breachClockStartedAt` starts the regulatory notification clock when `breach` is true
// - a legal deadline surfaced to counsel, never resolved by the crew (app-security §6).
import { z } from "zod";
import { AccountId, AppId, IncidentId } from "../ids.js";
import { Json, NonEmptyString, Timestamp } from "./common.js";
import { IncidentCause, IncidentSeverity, IncidentStatus } from "./enums.js";
export const Incident = z.object({
    id: IncidentId,
    accountId: AccountId,
    appId: AppId,
    severity: IncidentSeverity,
    status: IncidentStatus,
    cause: IncidentCause,
    /** True when this incident is a confirmed or suspected data breach. */
    breach: z.boolean(),
    /** When the breach-notification clock started; null unless `breach`. */
    breachClockStartedAt: Timestamp.nullable(),
    /** The event timeline (jsonb); the redacted subset feeds the public status page. */
    timeline: Json,
    /** The written post-mortem; null until resolved. */
    postmortem: NonEmptyString.nullable(),
    detectedAt: Timestamp,
    resolvedAt: Timestamp.nullable(),
});
//# sourceMappingURL=incident.js.map